import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-change-program',
  templateUrl: './change-program.component.html',
  styleUrls: ['./change-program.component.scss']
})
export class ChangeProgramComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
